/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import ExampleBackground from './background';
import type { Background, ColorAndComponents, ColorMode, Iconography, Typography } from './types';

type ExampleShowcaseProps = {
	backgroundColor?: Background;
	children: React.ReactNode;
	colorMode?: ColorMode;
	colorAndComponents?: ColorAndComponents;
	iconography?: Iconography;
	typography?: Typography;
	testId?: string;
};

const styles = cssMap({
	background: {
		borderTopLeftRadius: token('border.radius'),
		borderTopRightRadius: token('border.radius'),
		borderBlockEnd: `${token('border.width', '1px')} solid ${token('color.border')}`,
	},
	exampleContent: {
		color: token('color.text'),
		paddingBlock: token('space.200'),
		paddingInline: token('space.150'),
	},
});

/**
 * __Example showcase__
 *
 * An example showcase displays an example with code and link to codesandbox.
 *
 */
const ExampleShowcase = ({
	backgroundColor = 'checkered',
	children,
	colorMode,
	colorAndComponents,
	iconography,
	typography,
	testId,
}: ExampleShowcaseProps) => {
	return (
		<ExampleBackground
			background={backgroundColor}
			colorMode={colorMode}
			colorAndComponents={colorAndComponents}
			iconography={iconography}
			typography={typography}
			xcss={styles.background}
			testId={testId}
		>
			<Box xcss={styles.exampleContent}>{children}</Box>
		</ExampleBackground>
	);
};

export default ExampleShowcase;
